import { useEffect } from "react";
import { FormField } from "../../helpers/types";
import FormInputField from "./inputs/FormInputField";

function FormWrapper({
   fields,
   updateFormData,
   formData,
   cols
}: {
   fields: FormField[];
   updateFormData: Function;
   formData: Map<string, any>;
   cols?: number
}) {
   console.log({ formData })
   useEffect(() => {
      console.log("FormWrapper ...")
   }, [])
   return (
      <div className={`form grid grid-cols-${cols || 2} grid-flow-row gap-4`}>
         {fields.map((f, idx) => (
            <FormInputField key={idx} onChange={updateFormData} {...f} formData={formData} />
         ))}
      </div>
   );
}

export default FormWrapper;
